<template>
	
	<div >
		<div style="margin: auto;width: 50%;"><el-button @click="add()">新增问卷</el-button></div>
		<el-table :data="dataList" style="width: 50%;margin: auto;" v-loading="quLoading">
				      <el-table-column prop="name" label="问卷名称"></el-table-column>
	
				 <el-table-column prop="createTime" label="创建时间"></el-table-column>
			
			<el-table-column  label="操作栏(扫码填写问卷)" width="400">  <template slot-scope="scope">
	

		  <el-image 
		    style="width: 50px; height: 50px;margin-bottom: -7%;"
		    :src="scope.row.h5Url" 
		    :preview-src-list="[scope.row.h5Url]"
			title="扫码填写问卷">
		  </el-image>
	&nbsp;	&nbsp;	
			<el-button type='primary' @click="edit(scope.row.id)" v-if="scope.row.resultCount==0" >编辑</el-button>	
				<el-button type='warning' @click="loadResultPage(1,scope.row.id)" v-if="scope.row.resultCount>0" >查看结果</el-button>	
				
				<el-button type='primary'  v-if="scope.row.resultCount>0" @click="openMail(scope.row.id,scope.row.name)"
				title="只支持下载1000条,如超过1000请联系站长qq:1311168011">下载结果</el-button>
				&nbsp;	
				<el-popover
				  placement="top"
				  width="160"
				  v-model="scope.row.show">
				  <p>确认删除吗？</p>
				  <div style="text-align: right; margin: 0">
				    <el-button size="mini" type="text" @click="delClose(scope)">取消</el-button>
					
				    <el-button type="danger" size="mini" @click="deleteById(scope.row.id)">确定</el-button>
				  </div>
				  <el-button slot="reference" type="danger">删除</el-button>
				</el-popover>
				</template></el-table-column>
				
			
					</el-table>
				
				    <el-pagination
					style="width: 40%;margin: auto;"
				      @size-change="changeLimit"
				      @current-change="changePage"
				      :current-page="page"
				      :page-sizes="[5]"
				      :page-size="limit"
				      layout="total, sizes, prev, pager, next, jumper"
				      :total="total"
				    ></el-pagination>
					
					<!--弹窗-->
					
					<div>
						
						<el-dialog
						  title="问卷操作"
						  :visible.sync="dialogStatus"
						  width="30%"
									 :close-on-click-modal='false'
						  @close="resetForm"
						  
						>
						<div v-loading="addLoading">
						  <el-form :model="form" ref="formData" label-width="80px">
						    <el-form-item label="问卷名称">
						      <el-input v-model="form.name"></el-input>
						    </el-form-item>
						 <el-row>
						 	<el-col :span="19" :offset="1">
				              <h4>问卷问题 </h4>
						 	</el-col>
							
							<el-col :span="3" :offset="1">
						     <el-button  icon="el-icon-plus"  size="mini" style="margin-top: 25%;" @click="addQt()"></el-button>
							</el-col>
						 
						 </el-row>
						 <div v-for="(q,index) in form.qt">
						 <el-row >
						 	<el-col :span="5" :offset="1">
						       <el-select v-model="q.type" placeholder="请选择">
						          <el-option
						            v-for="item in options"
						            :key="item.value"
						            :label="item.label"
						            :value="item.value">
						          </el-option>
						        </el-select>
						 	</el-col>
						 							
						 							<el-col :span="12" :offset="1">
						   <el-input v-model="q.name"></el-input>
										  </el-col>
										  <el-col :span="4" :offset="1">
									
									<el-button   type="danger" @click="removeQt(index)">移除</el-button>
									
										  										  </el-col>
						 
						 </el-row>
						 <br>
						 </div>
						  </el-form>
						  <div slot="footer" class="dialog-footer" style="text-align: center;">
						    <el-button @click="close()">取消</el-button>
						    <el-button type="primary" @click="submit()">提交</el-button>
						  </div>
						  </div>
						</el-dialog>
						
						
						<el-dialog
						  title="查看问卷结果"
						  :visible.sync="resultDialogStatus"
						  width="40%"
									 :close-on-click-modal='false'
						 
						>
						  
						  <el-table :data="resultDataList" style="width: 100%;margin: auto;">
						  			      <el-table-column prop="idx" label="序号"></el-table-column>
						  <el-table-column prop="ip" label="提交ip"></el-table-column>
						  			 <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
						  		
						  		<el-table-column  label="操作栏" >  <template slot-scope="scope">
						  
				
						  		<el-popover
						  		  placement="top"
						  		  width="250"
						  		  trigger="click">
								  <h3 style="text-align: center;">填写内容</h3>
								  <br>
						  		<el-form label-width="80px">
						  		  <el-form-item :label="item.name" :key="item.id" v-for="item in JSON.parse(scope.row.content)">
						  		    <el-input v-model="item.qtAnswer" v-if="item.type==0" readonly="true"> </el-input>
						  		  </el-form-item>
						  		  
						  		</el-form>
						  		  <el-button slot="reference">查看详情</el-button>
						  		</el-popover>
						  			</template></el-table-column>
						  			
						  		
						  				</el-table>
						  			
						  			    <el-pagination
						  				
						  			      @size-change="changeResultLimit"
						  			      @current-change="changeResultPage"
						  			      :current-page="resultPage"
						  			      :page-sizes="[5]"
						  			      :page-size="resultLimit"
						  			      layout="total, sizes, prev, pager, next, jumper"
						  			      :total="resultTotal"
						  			    ></el-pagination>
						</el-dialog>
						
						
						
						<el-dialog
						  title="推送问卷结果"
						  :visible.sync="emailDialogStatus"
						  width="30%"
									 :close-on-click-modal='false'
						 
						>
						  <el-form label-width="80px" v-loading="emailLoading">
						    <el-form-item label="邮箱" >
						      <el-input v-model="emailForm.mailAddress" > </el-input>
						    </el-form-item>
							
						    <el-form-item>
						      <el-button type="primary" @click="sendMail">推送</el-button>
						    </el-form-item>
							
						  </el-form>
						
						</el-dialog>
					</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      dataList:[],
	  total:0,
	  page:1,
	  limit:5,
	  quLoading:false,
	  addLoading:false,
	  dialogStatus:false,
	  resultDataList:[],
	  resultTotal:0,
	  resultPage:1,
	  resultLimit:5,
	  idx:0,
	  resultDialogStatus:false,
	  questionnaireId:"",
	  form:{
		  name:"",
		  
		  qt:[]
	  },
	  options:[{
		  label:'填空',
		  value:0
	  }],
	  emailDialogStatus:false,
	  emailForm:{
	  		 name:"" ,
			 questionnaireId:"",
			 mailAddress:""
	  },
	  emailLoading:false,

   
    };
	
  },
  methods: {
	  openMail(questionnaireId,name){
		  this.emailDialogStatus=true;
		  this.emailForm.mailAddress=""
		   this.emailForm.questionnaireId=questionnaireId
		    this.emailForm.name=name
	  },
	  sendMail(){
		  if(this.emailForm.mailAddress==undefined||this.emailForm.mailAddress.trim()==""){
			  this.$notify({
			  	title: '消息提示',
			  	message: "邮箱地址不能为空！",
			  	type: 'error'
			  });
			  return
		  }
		  this.emailLoading=true
		  this.$api.exportQuestionnaireAnswerData(this.emailForm).then(res=>{
			  if(res.data.data){
				  this.$notify({
				  	title: '消息提示',
				  	message: "操作成功,请耐心等待邮件！",
				  	type: 'success'
				  });
				  this.emailDialogStatus=false;
			  }else{
				  this.$notify({
				  	title: '消息提示',
				  	message: res.data.msg,
				  	type: 'error'
				  });
			  }
			  this.emailLoading=false
			  
		  })
	  },
	  delClose(scope){
		console.log(scope)  
		this.dataList[scope.$index].show=false
		let temp=this.dataList
		this.dataList=[]
		setTimeout(function(data){
			data.dataList=temp
		},1,this)
	  },
	  add(){
		this.dialogStatus=true  
	  },
	  edit(id){
		  this.$api.getQuestionnaire({id:id}).then(res=>{
			  // this.form=res.data.data
			  this.form.id=res.data.data.id
			  this.form.name=res.data.data.name
			  this.form.qt=res.data.data.qt
			  this.dialogStatus=true
		  })
	  },
	  deleteById(id){
		  console.log('----------------')
		  this.$api.deleteQuestionnaire({id:id}).then(res=>{
			  if(res.data.data){
				  this.$notify({
				  	title: '消息提示',
				  	message: "操作成功！",
				  	type: 'success'
				  });
				  this.dataList=[]
				  
				  this.loadPage()
			  }else{
				  this.$notify({
				  	title: '消息提示',
				  	message: "操作失败！",
				  	type: 'error'
				  });
			  }
			  
		  })
		  
	  },
	  addQt(){
		this.form.qt.push({id:"",name:'',type:0})  
	  },
	  removeQt(index){
		  this.form.qt.splice(index,1)
	  },
	resetForm(){
		this.form={
		  name:"",
		  
		  qt:[]
	  }
	
	},
	close(){
		this.resetForm()
		this.dialogStatus=false
	},
	submit(){
		if(this.form.name==undefined||this.form.name.trim()==''){
			this.$notify({
				title: '消息提示',
				message: "问卷名称不能为空！",
				type: 'error'
			});
			return;
		}
		if(this.form.name.length>20){
			this.$notify({
				title: '消息提示',
				message: "问卷名称不能大于20！",
				type: 'error'
			});
			return;
		}
		let temp=new Set()
		for(let i=0;i<this.form.qt.length;i++){
			if(this.form.qt[i].name==undefined||this.form.qt[i].name.trim()==''){
				this.$notify({
					title: '消息提示',
					message: "问卷问题不能为空！",
					type: 'error'
				});
				return;
			}
			
			if(this.form.qt[i].name.length>20){
				this.$notify({
					title: '消息提示',
					message: "问卷问题名称不能大于20！",
					type: 'error'
				});
				return;
			}
			temp.add(this.form.qt[i].name)
		
			
		}
		if(this.form.qt.length!=temp.size){
			this.$notify({
				title: '消息提示',
				message: "问卷问题名称不能重复！",
				type: 'error'
			});
			return;
		}
		
		this.addLoading=true
		this.$api.saveOrUpdateQuestionnaire(this.form).then(res=>{
			if(res.data.data){
				this.$notify({
					title: '消息提示',
					message: "操作成功！",
					type: 'success'
				});
				this.page=1
				this.loadPage()
				this.dialogStatus=false
			}else{
				this.$notify({
					title: '消息提示',
					message: "操作失败！",
					type: 'error'
				});
			}
			this.addLoading=false
		})
		
	},
	loadPage(){
		this.quLoading=true
		this.$api.getQuestionnairePage({page:this.page,limit:this.limit}).then(res=>{
			this.dataList=res.data.data
			this.dataList.forEach(item=>{
				item.show=false
			})
			this.total=res.data.total
				this.quLoading=false
		})
	},
changePage(val){
	this.page=val
	this.loadPage()
},
changeLimit(val){
	this.limit=val
},
	loadResultPage(status,questionnaireId){
		if(status==1){
		this.resultDialogStatus=true
		this.questionnaireId=questionnaireId
		this.resultPage=1
	
	   }
		this.$api.getQuestionnaireAnswerPage({page:this.resultPage,limit:this.resultLimit,questionnaireId:this.questionnaireId}).then(res=>{
			this.resultDataList=res.data.data
			let maxIdx=this.resultPage*this.resultLimit
			let startIdx=maxIdx-this.resultLimit
			this.resultDataList.forEach(item=>{
				item.idx=++startIdx
			})
			this.resultTotal=res.data.total
		})
	},
changeResultPage(val){
	this.resultPage=val
	this.loadResultPage()
},
changeResultLimit(val){
	this.resultLimit=val
}
  },
  mounted() {
  	this.loadPage()
  }
};
</script>

<style>
</style>